import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, IKeyManagerAuditsAtLocation, KeyAudit } from "../../../logic/api";
import styles from "../styles";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import KeyAuditListItem from "../../../components/lists/listItems/KeyAuditListItem/KeyAuditListItem";
import AuditHistoryRow from "./condensedLayout/auditHistory/AuditHistoryRow";
import HeaderRow from "./condensedLayout/HeaderRow";

import usePaths from "../../../utility/paths";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";

const KeyAuditsAtLocation: React.FunctionComponent<{
  isCondensedView?: boolean;
  path: string;
}> = (props) => {
  const { t } = useTranslation();
  const paths = usePaths();
  const history = useHistory();
  const [params, setParams] = useState<IKeyManagerAuditsAtLocation>({
    path: props.path
  });
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);


  useEffect(() => {
    if (props.path != params.path) {
      setParams({
        ...params, path: props.path
      });
    }
  }, [props.path]);

  const handleOnClick = (item: KeyAudit) => {
    if (item.id != null) {
      const auditUrl = paths.keyManagerViewAudit(item.id);
      if (isOpenLinksInNewTab) {
        window.open(auditUrl, "_blank");
      } else {
        history.push(auditUrl);
      }
    }
  };

  return <div>
    {props.isCondensedView ? (<PagedDataView<IKeyManagerAuditsAtLocation, KeyAudit>
      apiHook={api.hooks.keyManager.getAuditsAtLocation}
      parameters={params}
      header={() => <HeaderRow columnHeaders={[t("locations.type"), t("locations.location"), t("locations.result"), t("locations.auditedBy"), t("locations.auditedAt"), ""]} />}
      isTable
      animate={false}
      renderItem={(item, index) => {
        return <AuditHistoryRow audit={item} auditType={t("locations.keyAudit")} rowIndex={index} onClick={() => handleOnClick(item)} />
      }}>
      <div style={styles.noData}>
        {t("locations.noAuditsFound")}
      </div>
    </PagedDataView>)
      :
      (<PagedDataView<IKeyManagerAuditsAtLocation, KeyAudit>
        apiHook={api.hooks.keyManager.getAuditsAtLocation}
        parameters={params}
        renderItem={(item) => {
          return <KeyAuditListItem item={item} onClick={() => handleOnClick(item)} />
        }}>
        <div style={styles.noData}>
          {t("locations.noAuditsFound")}
        </div>
      </PagedDataView>)}
  </div>
};

KeyAuditsAtLocation.propTypes = {
  path: propTypes.string.isRequired,
}

export default KeyAuditsAtLocation;
